export function charts(state = {}, action) {
  let currentChartData;

  switch (action.type) {
    case 'CHART_FILTER_CHANGE':
      if (action.chart) {
        currentChartData = state[action.chart] || {};

        return {
          ...state,
          [action.chart]: {
            ...currentChartData,
            ...action.data,
          },
        };
      }
      return {
        ...state,
        ...action.data,
      };

    case 'CHART_GET_REQUEST':
      currentChartData = (action.chartCode ? state[action.chartCode] : {}) || {};

      return {
        ...state,
        [action.chartCode]: {
          ...currentChartData,
          loading: true,
        },
      };
    case 'CHART_GET_RESPONSE':
      currentChartData = (action.chartCode ? state[action.chartCode] : {}) || {};

      return {
        ...state,
        [action.chartCode]: {
          ...currentChartData,
          ...action.payload,
          loading: false,
        },
      };
    default:
      return state;
  }
}
